/* eslint camelcase: 0, no-use-before-define: 0 */

// Same as has but it returns the value (or null) instead of a Boolean.
export function get(obj: object, key: string): any | null {
  if (has(obj, key)) {
    const parts = key.split('.')
    let val = obj

    for (let i = 0; i < parts.length; i += 1) {
      val = val[parts[i]]
    }

    return val
  }

  return null
}

// Checks to see if an object has a deep property. Lodash has this features but
// pulling that in added too much page weight, so I'm writing my own util
// function here.
export function has(obj: object, key: string): boolean {
  // don't mutate arguments.
  let editableObj = { ...obj }

  return key.split('.').every(prop => {
    if (typeof editableObj !== 'object' || editableObj === null) {
      return false
    }

    if (!Object.prototype.hasOwnProperty.call(editableObj, prop)) {
      return false
    }

    editableObj = editableObj[prop]

    return true
  })
}

// Pass it the number of the step and it'll log that event for you.
export function trackCheckoutStep(step: number) {
  const name = 'Completed Checkout Step'

  if (typeof window !== 'undefined') {
    // @ts-ignore
    window.trackTeachableGAEvent(name, { name, step })
  }
}
